import axiosInstance from '@/api/axios';

export function useUser() {
    const fetchUserData = async () => {
        try {
            const response = await axiosInstance.get('/users/find');
            if (response.data?.data) {
                return response.data.data;
            }
        } catch (error) {
            return null;
        }
        return null;
    }

    return { fetchUserData };
}




